import React, { useState } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "react-bootstrap";
import { getAdsAccount } from "../reducers/commonReducer";

const DateSelection = ({ onDateRangeChange, api, graph, adsAcc, setAddAccount }) => {
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const handleDateChange = (dates) => {
    setAddAccount(false);
    setDateRange(dates);
    if (onDateRangeChange) {
      onDateRangeChange(dates); // Pass dates to parent component
    }
    if (dates?.[0] && dates?.[1] && !graph) {
      dispatch(
        api({
          startDate: moment(dates?.[0]).format("YYYY/MM/DD"),
          endDate: moment(dates?.[1]).format("YYYY/MM/DD"),
        })
      );
    }
    // if (adsAcc && dates?.[0] && dates?.[1] && !graph) {
    //   dispatch(
    //     getAdsAccount({
    //       startDate: moment(dates[0]).format("YYYY-MM-DD"),
    //       endDate: moment(dates[1]).format("YYYY-MM-DD"),
    //     })
    //   );
    // }
  };
  return (
    <>
      <label>Date Range</label>
      <br />
      <DatePicker
        selected={startDate}
        onChange={handleDateChange}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        placeholderText="Select a date range"
        dateFormat="yyyy-MM-dd"
        popperPlacement="bottom-end"
        customInput={
          <button className="custom-date-input">
            {startDate && endDate
              ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
              : "Select a date range"}
          </button>
        }
      />
      {adsAcc && (
        <Button
          variant="info"
          className="mx-2"
          onClick={() => {
            setAddAccount(true);
            if (startDate && endDate) {
              dispatch(
                getAdsAccount({
                  startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
                  endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
                })
              );
            } else {
              dispatch(
                getAdsAccount({
                  startDate: moment().format("YYYY-MM-DD"),
                  endDate: moment().format("YYYY-MM-DD"),
                })
              );
            }
          }}
        >
          Ads Acc.
        </Button>
      )}
    </>
  );
};

export default DateSelection;
